(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["copyfast-apparel-catalog"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const categories=['all','tees','tanks','polos','sport','layers','outerwear','hats','gifts','promo','brands','womens','mens','unisex','youth','express','workwear','test'];
  function sortCatalog(section, sort) {
    const grid=section.querySelector('[data-copyfast-catalog-grid]');
    if(!grid || Number(grid.dataset.pages)>1) return false;
    const cards=Array.from(grid.querySelectorAll('.cfc-card'));
    cards.forEach((card,index)=>{if(!card.dataset.originalOrder)card.dataset.originalOrder=String(index+1);});
    const direction=sort.endsWith('descending')?-1:1;
    // default order: shirts first, then hoodies and sweatshirts, hats, the rest, gifts, and workwear last
    const ORDER=['tees','layers','hats','tanks','gifts','promo','polos','outerwear','sport'];
    const rank=card=>{const c=(card.dataset.category||'').split(' ');if(c.includes('workwear'))return 20;if(c.includes('tanks'))return 3;if(c.includes('gifts'))return 4;const k=ORDER.findIndex(o=>c.includes(o));return k<0?15:k;};
    cards.sort((a,b)=>{
      if(sort.startsWith('price-')) return direction*(Number(a.dataset.price)-Number(b.dataset.price));
      if(sort.startsWith('title-')) return direction*a.dataset.title.localeCompare(b.dataset.title);
      if(sort.startsWith('created-')) return direction*(Number(a.dataset.created)-Number(b.dataset.created));
      return (section.dataset.collection==='company-apparel'?0:(rank(a)-rank(b)))||(Number(a.dataset.originalOrder)-Number(b.dataset.originalOrder));   // company apparel keeps its own order: polos and workwear first
    });
    cards.forEach(card=>grid.appendChild(card));
    return true;
  }
  function filterCatalog(section,category){
    const grid=section.querySelector('[data-copyfast-catalog-grid]');
    if(!grid || Number(grid.dataset.pages)>1 || !section.querySelector('.cfc-categories [data-copyfast-filter]'))return;
    if(!categories.includes(category))category='all';
    let count=0;
    grid.querySelectorAll('.cfc-card').forEach(card=>{card.hidden=category!=='all' && !card.dataset.category.split(' ').includes(category);if(!card.hidden)count++;});
    section.querySelectorAll('.cfc-categories [data-copyfast-filter]').forEach(link=>{if(link.dataset.copyfastFilter===category)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
    const counter=section.querySelector('[data-copyfast-count]');
    counter.textContent=count===1?counter.dataset.singleCount:counter.dataset.countTemplate.replace('__COUNT__',String(count));
    section.querySelector('[data-copyfast-empty]').hidden=count>0;
  }
  function initialize(){document.querySelectorAll('.cfc').forEach(section=>{const seen=new Set();section.querySelectorAll('.cfc-card').forEach(card=>{const h=card.getAttribute('href'),k=card.dataset.title+'|'+card.dataset.price;if(seen.has(h)||seen.has(k))card.remove();else{seen.add(h);seen.add(k);}});const select=section.querySelector('[data-copyfast-sort]');if(select)sortCatalog(section,select.value);filterCatalog(section,new URL(location.href).searchParams.get('category') || 'all');});}
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-copyfast-filter]');if(!link)return;
    const section=link.closest('.cfc');if(Number(section.querySelector('[data-copyfast-catalog-grid]').dataset.pages)>1)return;
    event.preventDefault();const url=new URL(location.href);url.searchParams.set('category',link.dataset.copyfastFilter);url.searchParams.delete('page');url.hash='';
    window.history.pushState({},'',url);filterCatalog(section,link.dataset.copyfastFilter);
  });
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-copyfast-sort]'))return;
    const url=new URL(window.location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');
    if(sortCatalog(event.target.closest('.cfc'),event.target.value))window.history.replaceState({},'',url);
    else window.location.assign(url.href);
  });
  window.addEventListener('popstate',initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
